"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseAssignmentStyle = void 0;
var CourseAssignmentStyle;
(function (CourseAssignmentStyle) {
    CourseAssignmentStyle["WithSupport"] = "0";
    CourseAssignmentStyle["WithoutSupport"] = "1";
})(CourseAssignmentStyle = exports.CourseAssignmentStyle || (exports.CourseAssignmentStyle = {}));
